module.exports = __webpack_public_path__ + "img/Tool-adjustments.62d24cc4.svg";